import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Information = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="information-section">
        <div className="first-para">
          <h2>
            Decentralizing Trust in Gaming <span></span>
          </h2>
          <p>
            <span>Luckify</span> is redefining the world of chance-based gaming by putting fairness on-chain. From casino-style games and lotteries to loot boxes and prize draws, randomness fuels the excitement—but too often, it’s controlled in the shadows.
          </p>
          <p>
            Luckify flips the script with a <span>Verifiable Randomness Engine</span> powered by Chainlink VRF and the LUCK token, ensuring every outcome is tamper-proof, auditable, and economically grounded.
          </p>
        </div>
        <div className="first-para">
          <h2>
            How It Works <span></span>
          </h2>
          <ol className="rain-list">
            <li>
              Player initiates a request for randomness via smart contract
            </li>
            <li>
              Chainlink VRF delivers a cryptographically secure random number
            </li>
            <li>
              Smart contract verifies the number
            </li>
            <li>
              LUCK/BNB price data is optionally used to add contextual entropy
            </li>
            <li>
              The final result determines game outcomes on-chain
            </li>
          </ol>
        </div>
        <div className="first-para">
          <h2>
            Why It Matters <span></span>
          </h2>
          <ol className="rain-list">
            <li>
              <span>Zero Trust Required:</span>  Trust code, not centralized operators
            </li>
            <li>
              <span>On-Chain Transparency:</span>  Every outcome is verifiable and public
            </li>
            <li>
              <span>Tamper-Proof RNG:</span>  Secured by Chainlink VRF
            </li>
            <li>
              <span>Economic Anchoring:</span>  Token price adds real-world influence to results
            </li>
          </ol>
        </div>
        <div className="first-para">
          <h2>
            Use Cases <span></span>
          </h2>
          <ul>
            <li>Provably fair casino games & betting</li>
            <li>Public RNG for PvP & skill-based games</li>
            <li>Loot boxes, giveaways, NFT mints</li>
            <li>Developer integration via API & SDK</li>
          </ul>
        </div>
        <div className="first-para">
          <h2>
            Roadmap <span></span>
          </h2>
          <ul className="rain-list marginlist">
            <li>
              <span>v1:</span> Chainlink VRF + Token Price Integration (Live)
            </li>
            <li>
              <span>v2:</span> Community-powered entropy via staked LUCK
            </li>
            <li>
              <span>v3:</span> Fully decentralized RNG mesh governed by DAO-operated nodes
            </li>
          </ul>

        </div>
        <div className="first-para">
          <p>
            Each version deepens decentralization and increases fairness.
          </p>
        </div>
        <div className="first-para">
          <h2>
            Token Utility: $LUCK <span></span>
          </h2>
          <ul>
            <li>Pay for randomness requests</li>
            <li>Stake to power future RNG nodes</li>
            <li>Earn rewards by validating results</li>
            <li>Vote on ecosystem upgrades and parameters</li>
          </ul>
        </div>
        <div className="first-para">
          <h2>Allocation Highlights <span></span></h2>
          <div className="twice-tokenomics">
            {
              window.innerWidth < 600 ?
                <div>
                  <img src="\assets\alldetailpages\luckify\info\tokenomics-darkmbl.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\luckify\info\tokenomics-lightmbl.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
                :
                <div className="tokenomic-img">
                  <img src="\assets\alldetailpages\luckify\info\tokenomics-dark.png" alt="img" className='img-fluid hide-in-light-theme' />
                  <img src="\assets\alldetailpages\luckify\info\tokenomics-light.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
                </div>
            }
          </div>
        </div>

        {/* <div className="first-para">
          <h2>
            The Future is Fair <span></span>
          </h2>
          <p>Luckify isn’t just a gaming platform—it’s an open infrastructure for provable fairness. As we evolve our RNG engine, we’re reshaping the trust layer in games for the decentralized era.</p>
        </div> */}


      </section>


    </>
  );
};

export default Information;